import React from "react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

interface CustomConfirmModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  content?: string;
  width?: number; // width 속성 추가
}

const CustomConfirmModal: React.FC<CustomConfirmModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  title = "알림",
  content = "해당 정보를 삭제하시겠습니까?",
  width = 400, // 기본 width 값 설정
}) => {
  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent style={{ maxWidth: width }}>
        <DialogHeader className="text-center">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            {content}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <Button variant="outline" onClick={onCancel}>
            취소
          </Button>
          <Button onClick={onConfirm}>확인</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomConfirmModal;
